module.exports = __webpack_public_path__ + "img/sgt.d0593b15.svg";